

















import { Component, Vue } from "vue-property-decorator";
import { mutations } from "@/observables";

@Component({})
export default class extends Vue {
  /* Data */
  default = { id: -1, type: "ALL" } as Load.StatusLoadSelected;
  status = this.default;

  statusTypes = [
    { type: "REJECTED", id: 0 },
    { type: "ACCEPTED", id: 1 },
    { type: "TEMPORARY_ACCEPTED", id: 2 }
  ];

  /* Computed */
  get allStatus() {
    return [this.default, ...this.statusTypes];
  }

  /* methods */
  onChange() {
    mutations.setStatusTenderSelected(this.status);
    this.$emit("change");
  }
}
